
import React from 'react';
import { MainLink, Link } from '@/types/link-short';
import { ProfilePreview } from './ProfilePreview';
import { useAuth } from '@/hooks/use-auth';

interface LinkPreviewProps {
  mainLink: MainLink;
  links: Link[];
}

export function LinkPreview({ mainLink, links }: LinkPreviewProps) {
  const { user } = useAuth();

  const userProfile = {
    name: user?.name,
    avatar_url: user?.avatar_url,
    agency_name: user?.agency_name
  };

  return (
    <div className="h-full w-full">
      <ProfilePreview
        mainLink={mainLink}
        links={links}
        userProfile={userProfile}
        isPreview={true}
      />
    </div>
  );
}
